import React, { Component } from "react"
import '../App.css';


export default class Aptitfilms extends Component {
  render() {
  return (
    <div className="aptitoptions">
      <a href="https://en.wikipedia.org/wiki/Cold_Fever" target="_blank" rel="noopener noreferrer"><p className="apatitentry">&bull; Cold Fever</p></a>
      <a href="https://en.wikipedia.org/wiki/Ali:_Fear_Eats_the_Soul" target="_blank" rel="noopener noreferrer"><p className="apatitentry">&bull; Fear Eats The Soul</p></a>
      <a href="https://en.wikipedia.org/wiki/Light_Sleeper" target="_blank" rel="noopener noreferrer"><p className="apatitentry">&bull; Light Sleeper</p></a>
      <a href="https://en.wikipedia.org/wiki/Through_a_Glass_Darkly_(film)" target="_blank" rel="noopener noreferrer"><p className="apatitentry">&bull; Through a Glass Darkly</p></a>
      <a href="https://en.wikipedia.org/wiki/The_Color_of_Paradise" target="_blank" rel="noopener noreferrer"><p className="apatitentry">&bull; The Color of Paradise</p></a>
      <a href="https://en.wikipedia.org/wiki/Vagabond_(1985_film)" target="_blank" rel="noopener noreferrer"><p className="apatitentry">&bull; Vagabond</p></a>
      <a href="https://en.wikipedia.org/wiki/The_Hourglass_Sanatorium" target="_blank" rel="noopener noreferrer"><p className="apatitentry">&bull; The Hourglass Sanatorium</p></a>
      <a href="https://en.wikipedia.org/wiki/Waiting_for_Happiness" target="_blank" rel="noopener noreferrer"><p className="apatitentry">&bull; Waiting for Happiness</p></a>
      <a href="https://letterboxd.com/get_got/films/" target="_blank" rel="noopener noreferrer"><p className="apatitentrypage">&bull; Letterboxd &bull;</p></a>
    </div>
  )
}
}

